module.exports = __webpack_public_path__ + "img/1.7575a6d5.jpg";